<template>
  <div class="image-editor-container">
    <tui-image-editor
      ref="tuiImageEditor"
      :include-ui="useDefaultUI"
      :options="options"
      @addText="onAddText"
      @objectMoved="onObjectMoved"
    >
    </tui-image-editor>
  </div>
</template>

<script>
// Load Style Code
import 'tui-image-editor/dist/tui-image-editor.css';
import 'tui-color-picker/dist/tui-color-picker.css';
import { mapActions, mapGetters } from 'vuex';
import { ImageEditor } from '@toast-ui/vue-image-editor';
import { HTTP_FILES } from '../../core/http/http-file-common';
import Routing from '../../core/router/router';
const icona = require('tui-image-editor/dist/svg/icon-a.svg');
const iconb = require('tui-image-editor/dist/svg/icon-b.svg');
const iconc = require('tui-image-editor/dist/svg/icon-c.svg');
const icond = require('tui-image-editor/dist/svg/icon-d.svg');

var blackTheme = {
  // or white
  // main icons
  'menu.normalIcon.path': icond,
  'menu.activeIcon.path': iconb,
  'menu.disabledIcon.path': icona,
  'menu.hoverIcon.path': iconc,
};
var locale_ru_Fr = {
  Undo: 'Annuler',
  Redo: 'Refaire',
  Reset: 'Réinitialiser',
  Delete: 'Supprimer',
  'Delete-all': 'Supprimer tout',
  Crop: 'Recadrer',
  Flip: 'Miroir',
  Rotate: 'Pivoter',
  Draw: 'Dessiner',
  Shape: 'Formes',
  Icon: 'Icones',
  Text: 'Texte',
  Mask: 'Masque',
  Filter: 'Filtrer',
  Tint: 'Tenir',
  Multiply: 'Multiplier',
  Blend: 'Mélanger',
  Grayscale: 'Niv. de gris',
  Sepia: 'Sépia',
  Sepia2: 'Sépia 2',
  Invert: 'Inverser',
  Blur: 'Brouiller',
  Sharpen: 'Aiguiser',
  Emboss: 'Gaufrer',
  'Remove White': 'Supp. blanc',
  'Gradient-transparency': 'Niv. de gris',
  Brightness: 'Luminosité',
  Noise: 'Bruit',
  Pixelate: 'Pixellisation',
  'Color Filter': 'Couleur de filtre',
  Threshold: 'Seuil',
  Value: 'Valeur',
  Custom: 'Personnalisé',
  Square: 'Carré',
  Apply: 'Appliquer',
  Cancel: 'Annuler',
  Range: 'Intervalle',
  Free: 'Libre',
  Straight: 'Ligne',
  Color: 'Couleur',
  'Flip X': 'Miroir sur x',
  'Flip Y': 'Miroir sur y',
  Fill: 'Remplir',
  Stroke: 'Contour',
  Arrow: 'Flèche',
  Bold: 'Gras',
  Italic: 'Italique',
  Underline: 'Souligné',
  Left: 'Gauche',
  Center: 'Centre',
  Right: 'Droite',
  'Text size': 'Taille de texte',
  'Arrow-2': 'Flèche 2',
  'Arrow-3': 'Flèche 3',
  'Star-1': 'Etoile 1',
  'Star-2': 'Etoile 2',
  Heart: 'Coeur',
  Bubble: 'Boules',
  Location: 'Localisation',
  'Custom icon': 'Icone personnalisé',
  'No file chosen': 'Aucun fichier choisi',
  'Load Mask Image': 'Charger image de masque',
};

export default {
  name: 'ImageEditorContainer',
  components: {
    'tui-image-editor': ImageEditor,
  },
  data() {
    return {
      useDefaultUI: true,
      options: {
        includeUI: {
          theme: blackTheme,
          locale: locale_ru_Fr,
          initMenu: 'filter',
          loadImage: {
            path: '',
            name: 'Blank',
          },

          menuBarPosition: 'bottom',
        },
        cssMaxWidth: 700,
        cssMaxHeight: 500,
      },
      isVisible: false,
    };
  },
  watch: {
    imageEdited() {},
  },

  computed: {
    ...mapGetters({
      imageEdited: 'common/getImageEdited',
    }),
  },
  created() {
    this.options.includeUI.loadImage.path = this.imageEdited;
  },
  mounted() {
    var self = this;
    this.customUIEditorImaheTUI();
    var btns = document.querySelectorAll('.tui-image-editor-item.normal');
    var btnSave = document.getElementById('saveBtn');
    var btnCancel = document.getElementById('cancelBtn');
    btns.forEach(button => {
      button.addEventListener('click', () => {
        if (button.id === 'tie-btn-crop') {
          btnSave.style.display = 'none';
          btnCancel.style.display = 'none';
        } else {
          btnSave.style.display = 'inline-block';
          btnCancel.style.display = 'inline-block';
        }
      });
    });
    var btnsAfterCrop = document.getElementById('tie-crop-button');

    btnsAfterCrop.addEventListener('click', () => {
      btnSave.style.display = 'inline-block';
      btnCancel.style.display = 'inline-block';
    });
    document.querySelector('.spinner-border').style.display = 'none';
  },

  methods: {
    ...mapActions('common', ['setImageEdited']),
    customUIEditorImaheTUI() {
      let saveButton = document.createElement('button');
      saveButton.className = 'tui-image-editor-save-btn';
      saveButton.id = 'saveBtn';
      saveButton.innerHTML =
        '<span id="spinner-border"class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Enregistrer';
      let cancelButton = document.createElement('button');
      cancelButton.className = 'tui-image-editor-cancel-btn';
      cancelButton.id = 'cancelBtn';
      cancelButton.innerText = 'Annuler';

      document.querySelector('.tui-image-editor-header-logo').style.display = 'none';
      let downloadButton = document.querySelector(
        '.tui-image-editor-header-buttons .tui-image-editor-download-btn',
      );
      downloadButton.replaceWith(cancelButton);

      let LoadButton = document.querySelectorAll('.tui-image-editor-load-btn')[1].parentElement;
      LoadButton.replaceWith(saveButton);

      saveButton.addEventListener('click', this.onSaveImage);
      cancelButton.addEventListener('click', this.onColseEditor);
    },
    hiddenBtn() {
      btnSave.style.display = 'none';
      btnCancel.style.display = 'none';
    },
    onAddText(res) {
      console.group('addText');
      console.groupEnd();
    },
    onObjectMoved(res) {
      console.group('objectMoved');
      console.groupEnd();
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    onSaveImage() {
      document.querySelector('.spinner-border').style.display = 'inline-block';
      var self = this;
      var imageEditor = this.$refs.tuiImageEditor;
      var dataurl = imageEditor.invoke('toDataURL', 'image/jpeg');
      var file = this.dataURLtoFile(dataurl, 'image1');
      var formData = new FormData();
      formData.append('empApiFileForm[thumb]', file); //containing all the selected images from local
      formData.append('_format', 'json'); //containing all the selected images from local
      HTTP_FILES(window.ApiToken)
        .post(Routing.generate('api_bloc_post_thumb'), formData)
        .then(
          function(response) {
            if (response && response.data && response.data.code == 200) {
              document.querySelector('.spinner-border').style.display = 'none';

              var image = response.data.location.url;

              grapesjs.editors[0].AssetManager.add(image);

              try {
                try {
                  grapesjs.editors[0].getSelected().attributes.attributes.src = image;
                } catch (e) {
                  console.log(e);
                }

                grapesjs.editors[0].getSelected().attributes.src = image;
                grapesjs.editors[0].getSelected().set('src', image);
                self.setImageEdited(image);


                document
                  .querySelector('.gjs-frame')
                  .contentWindow.document.querySelector('.gjs-comp-selected')
                  .children[0].setAttribute('src', self.imageEdited);
              } catch (e) {
                console.log(e);
              }
              eventHub.$emit('eventShowEditorImage', false);
            }
          },
          function(response) {
            //self.hideLoader();
          },
        );
    },
    onColseEditor() {
      eventHub.$emit('eventShowEditorImage', false);
      this.setImageEdited('');
    },
  },
};
</script>

<style>
.tui-image-editor-save-btn {
  background-color: #57ad66;
  border: 1px solid #ddd;
  color: #ffff;
  font-family: 'Noto Sans', sans-serif;
  font-size: 12px;
}
.tui-image-editor-save-btn {
  background-color: #2196f3;
  border: 1px solid #ddd;
  color: #ffff;
  font-family: 'Noto Sans', sans-serif;
  font-size: 12px;
}
.tui-image-editor-cancel-btn {
  background-color: #fff;
  border: 1px solid #2196f3;
  color: #2196f3;
  font-family: 'Noto Sans', sans-serif;
  font-size: 12px;
}

.tui-image-editor-container.bottom {
  z-index: 1;
  width: 62rem;
  height: 90vh !important;
}

.image-editor-container {
  width: 1000px;
  height: 800px;
}
.tui-image-editor-container .tui-image-editor-submenu-align {
  margin: 0 !important;
}
.tui-image-editor-wrap {
  position: relative;
}
.tui-image-editor {
  top: -75px !important;
  left: 0px;
  height: 55vh !important;
  width: 43%;
}
</style>



// WEBPACK FOOTER //
// ImageEditorContainer.vue?7319b332